import React from 'react';
import RescaleIcon from 'material-icons-svg/components/baseline/CenterFocusWeak';
import ZoomInIcon from 'material-icons-svg/components/baseline/ZoomIn';
import ZoomOutIcon from 'material-icons-svg/components/baseline/ZoomOut';
import './GraphControls.scss';
function rescale(renderer) {
    var camera = renderer.getCamera();
    camera.animatedReset({}); // TODO: simplify when sigma typings are fixed
}
function zoomIn(renderer) {
    var camera = renderer.getCamera();
    camera.animatedZoom(1.5); // TODO: simplify when sigma typings are fixed
}
function zoomOut(renderer) {
    var camera = renderer.getCamera();
    camera.animatedUnzoom(1.5); // TODO: simplify when sigma typings are fixed
}
export function ControlButton(_a) {
    var Icon = _a.Icon, onClick = _a.onClick;
    return (React.createElement("div", { className: "control-button", onClick: onClick },
        React.createElement(Icon, { height: 32, width: 32 })));
}
export default function GraphControls(_a) {
    var renderer = _a.renderer;
    return (React.createElement("div", { id: "GraphControls" },
        React.createElement(ControlButton, { Icon: RescaleIcon, onClick: function () { return rescale(renderer); } }),
        React.createElement(ControlButton, { Icon: ZoomInIcon, onClick: function () { return zoomIn(renderer); } }),
        React.createElement(ControlButton, { Icon: ZoomOutIcon, onClick: function () { return zoomOut(renderer); } })));
}
